import ReportsView from "../ReportsView.vue";
import ReportVisitBuilderView from "../ReportVisitBuilderView.vue";
import ReportLayoutEditorView from "../ReportLayoutEditorView.vue";
import ReportVisitPreviewView from "../ReportVisitPreviewView.vue";

export const reportRoute = [
  {
    path: "/reports",
    name: "reports-home",
    component: ReportsView,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: "login" });
      next();
    },
    meta: {
      key: "view_rep",
    },
  },
  {
    path: "/reports/visits/:id/builder",
    name: "reports-visit-builder",
    component: ReportVisitBuilderView,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: "login" });
      next();
    },
    meta: {
      key: "view_rep",
    },
  },
  {
    path: "/reports/visits/:id/preview",
    name: "reports-visit-preview",
    component: ReportVisitPreviewView,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: "login" });
      next();
    },
    meta: {
      key: "view_rep",
    },
  },
  {
    path: "/reports/layouts/:id/editor",
    name: "reports-layout-editor",
    component: ReportLayoutEditorView,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: "login" });
      next();
    },
    meta: {
      key: "view_rep",
    },
  },
];